import { useAudio } from "../context/AudioProvider";
import { useTick } from "../hooks/useTick";
import { Volume2, VolumeX, Menu, X } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const LINKS = [
  { label: "Services", id: "services" },
  { label: "Why Us", id: "manifesto" },
  { label: "About", id: "about" },
  { label: "Book", id: "booking" },
];

export const Header = () => {
  const { playing, toggle } = useAudio();
  const tick = useTick();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const go = (id) => {
    tick(660);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setOpen(false);
  };

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-[100] backdrop-blur-xl bg-background/80 border-b border-border"
    >
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="logo-home"
          onClick={() => { tick(); window.scrollTo({ top: 0, behavior: "smooth" }); }}
          className="font-display font-black text-sm md:text-base tracking-tighter uppercase leading-none text-left"
        >
          BioFleet<span className="text-primary">/</span>Soulat
          <span className="block text-[9px] tracking-[0.3em] text-muted-foreground font-mono font-normal mt-0.5">
            COURIERS & TESTING LLC
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground hover:text-primary transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-pay"
            onClick={() => { tick(); nav("/pay"); }}
            className="text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground hover:text-primary transition-colors duration-300"
          >
            Pay
          </button>
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="audio-toggle"
            onClick={() => { tick(); toggle(); }}
            aria-label="Toggle background music"
            className="w-10 h-10 border border-border flex items-center justify-center hover:border-primary hover:text-primary transition-colors duration-300"
          >
            {playing ? <Volume2 size={16} /> : <VolumeX size={16} />}
          </button>
          <button
            data-testid="client-portal-btn"
            onClick={() => { tick(); nav("/admin"); }}
            className="hidden sm:block bg-primary text-primary-foreground font-mono uppercase tracking-[0.15em] text-[10px] font-bold py-3 px-5 border border-primary hover:bg-transparent hover:text-primary transition-colors duration-300"
          >
            Client Portal
          </button>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="md:hidden w-10 h-10 border border-border flex items-center justify-center"
          >
            {open ? <X size={16} /> : <Menu size={16} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-border bg-background px-5 py-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="client-portal-mobile"
            onClick={() => nav("/admin")}
            className="text-left text-xs font-mono uppercase tracking-[0.2em] text-primary"
          >
            Client Portal
          </button>
          <button
            data-testid="nav-mobile-pay"
            onClick={() => nav("/pay")}
            className="text-left text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground"
          >
            Pay
          </button>
        </div>
      )}
    </header>
  );
};
